import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const ChevronUp20 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={20}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M16.5303 11.9697L15.4697 13.0303L10 7.56065L4.53032 13.0303L3.46967 11.9697L10 5.43933L16.5303 11.9697Z'
      fill='currentColor'
    />
  </Svg>
);

ChevronUp20.displayName = 'ChevronUp20';
export default ChevronUp20;
